import { useSelector } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'

export const useGetUsersSelector = () => useSelector((state) => state[orderSlice.name].users)
